
document.addEventListener('DOMContentLoaded', function() {

  /* CUSTOM FILTER */
  if(document.querySelector("#mit-size")) {


    // Function to check URL parameters
    function checkURLParams() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.toString() === '') {
          document.querySelectorAll("#mit-filter-btns button").forEach(btn => {
            btn.classList.remove("selected")
          })
    
          if(window.location.href.includes("/en/")) {
            document.querySelector("#mit-size .mit_dropdown-button").innerHTML = `\n            SELECT OPTION \n            <span class="caret"></span>\n            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15">\n              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"></path>\n            </svg>\n   `;
            document.querySelector("#mit-material .mit_dropdown-button").innerHTML = `\n            SELECT OPTION \n            <span class="caret"></span>\n            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15">\n              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"></path>\n            </svg>\n   `;
          } else {
            document.querySelector("#mit-size .mit_dropdown-button").innerHTML = `\n            OPTION AUSWÄHLEN \n            <span class="caret"></span>\n            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15">\n              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"></path>\n            </svg>\n   `;
            document.querySelector("#mit-material .mit_dropdown-button").innerHTML = `\n            OPTION AUSWÄHLEN \n            <span class="caret"></span>\n            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15">\n              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"></path>\n            </svg>\n   `;
          }
          
        } 
    }
    
    // Check immediately when the script loads
    checkURLParams();
    
    // Monitor URL changes
    let lastUrl = location.href; 
    new MutationObserver(() => {
        const url = location.href;
        if (url !== lastUrl) {
            lastUrl = url;
            checkURLParams();
        }
    }).observe(document, {subtree: true, childList: true});
    
    // Get the current URL
    const urlParams = new URLSearchParams(window.location.search);
    
    // Decode the values
    const filterSizeValue = urlParams.get("filter.v.option.größe");
    const filterMaterialValue = urlParams.get("filter.v.option.material");
    const filterAvailabilityValue = urlParams.get("filter.v.m.custom.availability");
    
    if (filterSizeValue) {
      const dropDownBtn = document.querySelector("#mit-size .mit_dropdown-button");
      dropDownBtn.innerHTML = `\n            ${filterSizeValue} \n            <span class="caret"></span>\n            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15">\n              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"></path>\n            </svg>\n   `;
    }

    if(filterMaterialValue) {
      const dropDownBtn = document.querySelector("#mit-material .mit_dropdown-button");
      dropDownBtn.innerHTML = `\n            ${filterMaterialValue} \n            <span class="caret"></span>\n            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15">\n              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"></path>\n            </svg>\n   `;
    }

    if(filterAvailabilityValue && filterAvailabilityValue === "Sofort verfügbar") {
        document.querySelector("#mit-sofort").classList.add("selected");   
    }

    if(filterAvailabilityValue && filterAvailabilityValue === "Auf Bestellung genäht") {
        document.querySelector("#mit-auf-bestellung").classList.add("selected");   
    }

    const dropdownButtons = document.querySelectorAll('.mit-custom-filter-dropdown .mit_dropdown-button');
    const dropdownContents = document.querySelectorAll('.mit-custom-filter-dropdown .mit_dropdown-content');

    const alleButton = document.querySelector('#mit-alle');
    const sofortButton = document.querySelector('#mit-sofort');
    const bestellungButton = document.querySelector('#mit-auf-bestellung');
    const filterButtons = document.querySelector("#mit-filter-btns");

    dropdownButtons.forEach(dropdownButton => {
      dropdownButton.addEventListener('click', (event) => {
        event.stopPropagation(); 
        const dropdownContent = dropdownButton.parentElement.querySelector(".mit_dropdown-content")
        dropdownContent.style.display = dropdownContent.style.display === 'flex' ? 'none' : 'flex';
      }); 
    })
    
    dropdownContents.forEach(dropdownContent => {
      // Prevent closing when clicking inside the dropdown content
      dropdownContent.addEventListener('click', (event) => {
          event.stopPropagation();
      });

      // Select size event listener
      dropdownContent.addEventListener("click", e => {
        if(e.target.nodeName === "INPUT") {
  
          // Clear all selected values first
          const parentElement = dropdownContent.parentElement.id;

          if(dropdownContent.parentElement.id === "mit-material") clearFilter(parentElement);
  
          setTimeout(function() {
            if(dropdownContent.parentElement.id === "mit-material") {
                dropdownContent.querySelectorAll("input").forEach(input => {
                if(input.checked) input.checked = false;
                input.parentElement.classList.remove("selected")
              })  
            }
            
    
            // Get the size input id and toggle the original filter
            const sizeInput = e.target.id;
            e.target.checked = true;
            sizeInputCapitalized = capitalizeWords(sizeInput)
            if(!window.location.href.includes("/en/")) {
              const translatedInput = sizeInputCapitalized.replace("Size", "Größe")
              const originalSizeInput = document.querySelector(`.facets__display #${translatedInput}`);
              originalSizeInput.click();

              // Click one size
              if(document.querySelector("input[value='One Size']")) {
                const oneSizeInput = document.querySelector(`.facets__display input[value='One Size']`)
                if(oneSizeInput.checked === false) oneSizeInput.click();  
              }
              
            } else {
              const originalSizeInput = document.querySelector(`.facets__display #${sizeInputCapitalized}`);
              originalSizeInput.click();  

              if(document.querySelector("input[value='One Size']")) {
                const oneSizeInput = document.querySelector(`.facets__display input[value='One Size']`)
                if(oneSizeInput.checked === false) oneSizeInput.click();  
              }
              
            }
            
          }, 1000)
   
        }
      })
    })

    document.addEventListener('click', () => {
      dropdownContents.forEach(dropdownContent => {
        dropdownContent.style.display = 'none';
      });
    });

    

    filterButtons.addEventListener("click", e => {
      if(e.target.nodeName === "BUTTON") {
        const targetBtn = e.target;
        const targetBtnId = targetBtn.id;

        switch(targetBtnId) {
          case "mit-alle":
            clearAvailabilityChoice();
            filterButtons.querySelectorAll("button").forEach(btn => btn.classList.remove("selected"))
            targetBtn.classList.add("selected");
            break;

          case "mit-sofort":
            clearAvailabilityChoice();
            filterButtons.querySelectorAll("button").forEach(btn => btn.classList.remove("selected"))
            window.location.href.includes("/en/") ? setMitFilterBtn("Sofort verfügbar") : setMitFilterBtn("Sofort verfügbar")
            if(!document.querySelector(`input[value='Sofort verfügbar']`)) {
              document.querySelector("#mit-sofort").style.opacity = "0.5";
            } else {
              document.querySelector("#mit-sofort").style.opacity = "1";
            }
            targetBtn.classList.add("selected");
            break;
            
          case "mit-auf-bestellung":
            clearAvailabilityChoice();  
            filterButtons.querySelectorAll("button").forEach(btn => btn.classList.remove("selected"))
            window.location.href.includes("/en/") ? setMitFilterBtn("Auf Bestellung genäht") : setMitFilterBtn("Auf Bestellung genäht")
            if(!document.querySelector(`input[value='Auf Bestellung genäht']`)) {
              document.querySelector("#mit-auf-bestellung").style.opacity = "0.5";
            } else {
              document.querySelector("#mit-auf-bestellung").style.opacity = "1";
            }
            targetBtn.classList.add("selected");           
            break;
        }
      }
    })

    function clearAvailabilityChoice() {
      const availabilityFilter = document.querySelectorAll("facet-remove")[1].parentElement;
      const availabilityFilterReset = availabilityFilter.querySelector("facet-remove a")
      availabilityFilterReset.click();
    }

    function setMitFilterBtn(targetBtnId) {
      setTimeout(function() {

        if(document.querySelector(`input[value='${targetBtnId}']`)) document.querySelector(`input[value='${targetBtnId}']`).click();
        
        //if(document.querySelector(`input[id="${targetBtnId}"]`)) document.querySelector(`input[id="${targetBtnId}"]`).click();  
      }, 1000);
    }

    function clearFilter(id) {
      switch(id) {
        case "mit-size":
          document.querySelectorAll("facet-remove")[0].parentElement.querySelector("facet-remove a").click();
          break;
        case "mit-material":
          document.querySelectorAll("facet-remove")[2].parentElement.querySelector("facet-remove a").click();
          break;
      }
    }

    function capitalizeWords(str) {
      return str
        .split('-') // Split the string into words using '-' as a delimiter
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
        .join('-'); // Join the words back with '-'
    }


    // Filter configurations
    const filterConfigs = [
      {
        themeSelector: '.js-filter[data-index="1"]',
        customSelector: '#mit-size .mit_dropdown-content',
        type: 'size'
      },
      {
        themeSelector: '.js-filter[data-index="3"]',
        customSelector: '#mit-material .mit_dropdown-content',
        type: 'material'
      }
    ];
    
    // Class to handle filter observation and updates
    class FilterObserver {
      constructor(config) {
        this.themeElement = document.querySelector(config.themeSelector);
        this.customDropdown = document.querySelector(config.customSelector);
        this.type = config.type;
        this.observer = null;
        this.filterSelector = config.themeSelector; // Store the selector for later use
      }
    
      updateCustomFilter(filterValues) {    
        if (!this.customDropdown) {
          console.error(`Custom ${this.type} filter dropdown not found`);
          return;
        }
    
        // Clear existing content
        this.customDropdown.innerHTML = '';
        
        // Create new filter items
        filterValues.forEach((item, index) => {
          const originalLabel = item.querySelector('label');
          if (!originalLabel) {
            console.warn("No label found for item:", item);
            return;
          }
    
          const label = document.createElement('label');
          const originalTitle = originalLabel.getAttribute('title');
          
          label.setAttribute('for', `Filter-${this.type}-${index + 1}`);
          label.setAttribute('title', originalTitle);
          
          const input = document.createElement('input');
          input.type = 'checkbox';
          input.name = `filter.v.option.${this.type.toLowerCase()}`;
          input.value = originalTitle;
          input.id = `Filter-${this.type}-${index + 1}`;
          
          // Check if the item is disabled
          const originalInput = item.querySelector('input');
          if (originalInput) {
            input.disabled = originalInput.disabled;
            input.checked = originalInput.checked;
          }
          
          const iconSpan = document.createElement('span');
          iconSpan.className = 'icon';
          
          const text = document.createTextNode(originalLabel.textContent.trim());
          
          label.appendChild(input);
          label.appendChild(iconSpan);
          label.appendChild(text);
          
          this.customDropdown.appendChild(label);
        });
    
        if(!document.querySelector(`input[value='Sofort verfügbar']`)) {
          document.querySelector("#mit-sofort").style.opacity = "0.5";
        } else {
          document.querySelector("#mit-sofort").style.opacity = "1";
        }
    
        if(!document.querySelector(`input[value='Auf Bestellung genäht']`)) {
          document.querySelector("#mit-auf-bestellung").style.opacity = "0.5";
        } else {
          document.querySelector("#mit-auf-bestellung").style.opacity = "1";
        }


        // Add selected option to filter button
        // Get the current URL
        const urlParams = new URLSearchParams(window.location.search);
        
        // Decode the values
        const filterSizeValue = urlParams.get("filter.v.option.größe");
        const filterMaterialValue = urlParams.get("filter.v.option.material");

        if (filterSizeValue) {
          const dropDownBtn = document.querySelector("#mit-size .mit_dropdown-button");
          dropDownBtn.innerHTML = `\n            ${filterSizeValue} \n            <span class="caret"></span>\n            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15">\n              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"></path>\n            </svg>\n   `;
        }
    
        if(filterMaterialValue) {
          const dropDownBtn = document.querySelector("#mit-material .mit_dropdown-button");
          dropDownBtn.innerHTML = `\n            ${filterMaterialValue} \n            <span class="caret"></span>\n            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15">\n              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"></path>\n            </svg>\n   `;
        }
        
        
        
      }
    
      initializeObserver() {
        if (!this.themeElement || !this.customDropdown) {
          console.error(`Required elements for ${this.type} not found, retrying...`);
          setTimeout(() => this.initializeObserver(), 1000);
          return;
        }
        
        const config = {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['checked', 'disabled', 'class'],
          characterData: true
        };
    
        this.observer = new MutationObserver((mutations) => {
          const shouldUpdate = mutations.some(mutation => {
            return this.themeElement.contains(mutation.target) ||
                   mutation.target === this.themeElement;
          });
    
          if (shouldUpdate) {
            const filterItems = this.themeElement.querySelectorAll('.list-menu__item');
            this.updateCustomFilter(filterItems);
          }
        });
    
        // Start observing the entire filter container
        this.observer.observe(this.themeElement, config);
        
        // Initial update
        const filterItems = this.themeElement.querySelectorAll('.list-menu__item');
        this.updateCustomFilter(filterItems);
        
        // Also observe the parent elements for any dynamic changes
        const parentElement = this.themeElement.closest('.js-filter');
        if (parentElement) {
          this.observer.observe(parentElement, config);
        }
    
        // Add click event listener
        document.addEventListener('click', (event) => {
          // Check if the clicked element is within the filter area
          const filterArea = document.querySelector(this.filterSelector);
          if (filterArea && filterArea.contains(event.target)) {
            const filterItems = this.themeElement.querySelectorAll('.list-menu__item');
            this.updateCustomFilter(filterItems);
          }
        });
      }
    
      disconnect() {
        if (this.observer) {
          this.observer.disconnect();
        }
      }
    }
    
    // Initialize all filters
    let filterObservers = [];
    
    // Function to initialize observers
    function initializeObservers() {
      // Clean up existing observers first
      if (filterObservers.length > 0) {
        filterObservers.forEach(observer => observer.disconnect());
        filterObservers = [];
      }
    
      // Create new observers
      filterObservers = filterConfigs.map(config => new FilterObserver(config));
      
      // Initialize each observer
      filterObservers.forEach(observer => observer.initializeObserver());
    }
    
    // Start initialization with a small delay to ensure DOM is ready
    setTimeout(initializeObservers, 1000);
    
    // Clean up observers when needed
    window.addEventListener('unload', () => {
      filterObservers.forEach(observer => observer.disconnect());
    });    
   
  }

/* END OF CUSTOM FILTER */



if(document.querySelector("#mit-open-chat")) {
  document.querySelector("#mit-open-chat").addEventListener("click", () => {
    document.querySelector("#PopupModal-mit_additional_info_FN9iKh-3").click()
    document.querySelector("#shopify-chat #ShopifyChat").shadowRoot.querySelector("button").click()  
  })
}


  if(window.location.pathname.includes("/en/")) {

    setTimeout(function() {

      if(document.querySelector("#Filter-Availability of products-mobile-1")) {

      // Select the label element
      const label = document.querySelector("label[for='Filter-Availability of products-mobile-1']");
      
      if (label) {
        // Get the current HTML content
        const html = label.innerHTML;
    
        // Replace the German text before the '(' while preserving the HTML structure
        const updatedHtml = html.replace(/Auf Bestellung genäht&nbsp;/, 'Made to Order&nbsp;');
    
        // Update the label's innerHTML with the translated version
        label.innerHTML = updatedHtml;
      }

    }

    if(document.querySelector("#Filter-Availability of products-mobile-2")) {

      // Select the label element
      const label = document.querySelector("label[for='Filter-Availability of products-mobile-2']");
      
      if (label) {
        // Get the current HTML content
        const html = label.innerHTML;
    
        // Replace the German text before the '(' while preserving the HTML structure
        const updatedHtml = html.replace(/Sofort verfügbar&nbsp;/, 'Available immediately&nbsp;');
    
        // Update the label's innerHTML with the translated version
        label.innerHTML = updatedHtml;
      }
      
    }
      
    }, 1000)
    
    
    
  }

  
  if(document.querySelector("modal-dialog")) {
    // Select all <modal-dialog> elements
    const modals = document.querySelectorAll("modal-dialog");
    const header = document.querySelector("sticky-header");

    // Function to check if any modal is open
    function checkModalsVisibility() {
        // If any modal has the "open" attribute, hide the header
        const anyModalOpen = Array.from(modals).some(modal => modal.hasAttribute("open"));
        if (anyModalOpen) {
            header.style.opacity = "0";
            header.style.display = "none";
        } else {
            header.style.opacity = "1";
            header.style.display = "block";
        }
    }

    // Observe each modal for changes to the "open" attribute
    modals.forEach(modal => {
        const observer = new MutationObserver(() => {
            checkModalsVisibility();
        });

        // Start observing the modal for attribute changes
        observer.observe(modal, { attributes: true, attributeFilter: ["open"] });
    });

    // Initial check to set the correct header visibility on page load
    checkModalsVisibility(); 
  }
  



  

  if(document.querySelectorAll('.mit-variant-options-select')) {
    const selectFields = document.querySelectorAll('.mit-variant-options-select'); // Select all <select> fields with the class

    selectFields.forEach(function(selectField) {
      selectField.addEventListener('change', function() {
        
        setTimeout(function() {
          let submitButton = undefined;

          // Dan ithelps
          if(document.querySelector('.mit-inquiry-button')) {
             submitButton = document.querySelector('.mit-inquiry-button');
          } 
          if(document.querySelector('.mit-atc-btn')) var submitButtonText = document.querySelector('.mit-atc-btn').textContent.trim();
          // Dan ithelps
          
          if (submitButton) {
            if(document.querySelector('.mit-atc-btn').textContent.trim() === 'Sold out' || document.querySelector('.mit-atc-btn').textContent.trim() === 'Ausverkauft') {
              submitButton.classList.add('mit-not-visible');
              document.querySelector('.mit-atc-btn').classList.remove('mit-not-visible');
              document.querySelector('.mit-price-div').classList.remove('mit-not-visible');
            } else {
              submitButton.classList.remove('mit-not-visible');
              document.querySelector('.mit-atc-btn').classList.add('mit-not-visible');
              document.querySelector('.mit-price-div').classList.add('mit-not-visible');
            }
          }
        }, 1000);
      });
    });

  function clickFirstOption(selectElements, customSelectElements) {
    const dropdowns = Array.from(customSelectElements);
    let lastOriginalSelect = null;

    dropdowns.forEach(customDropdown => {
        if (!customDropdown) return;

        // Prefer the pre-selected li (with stock), fall back to first li
        let targetOption = customDropdown.querySelector(".dropdown-list li.selected")
            || customDropdown.querySelector(".dropdown-list li");
        if (!targetOption) return;

        const dropdownHeader = customDropdown.querySelector('.dropdown-header');
        if (!dropdownHeader) return;

        const dropdownDataId = customDropdown.getAttribute("data-id");
        if (!dropdownDataId) return;

        let originalSelect = document.querySelector(`#${dropdownDataId}`);
        if (!originalSelect) return;

        const value = targetOption.getAttribute('data-value');
        if (value === null) return;

        // Update custom dropdown header and sync select value
        dropdownHeader.textContent = targetOption.textContent;
        originalSelect.value = value;
        lastOriginalSelect = originalSelect;
    });

    // Fire change only once after ALL dropdowns are set
    // so updateMasterId() finds the correct variant
    if (lastOriginalSelect) {
        const changeEvent = new Event('change', { bubbles: true });
        lastOriginalSelect.dispatchEvent(changeEvent);
    }
}

    
    clickFirstOption(selectFields, document.querySelectorAll(".custom-dropdown")); 
    /*if(document.querySelector("li[data-first='true']")) {
      setTimeout(function() {
        console.log("click now")
        document.querySelector("li[data-first='true']").click();
      }, 500)
    }*/

    // First, prevent scroll temporarily during the click
    if(document.querySelector("li[data-first='true']")) {
      setTimeout(function() {
        // Save current scroll position
        const scrollPos = window.scrollY;
        
        // Add scroll prevention - multiple approaches
        const preventDefault = (e) => {
          e.preventDefault();
          window.scrollTo(0, scrollPos);
        };
        
        // Temporarily lock body position
        const originalStyle = document.body.style.cssText;
        document.body.style.cssText = `
          position: fixed;
          top: -${scrollPos}px;
          left: 0;
          right: 0;
        `;
        
        // Add multiple event listeners to ensure scroll prevention
        window.addEventListener('scroll', preventDefault, { passive: false });
        document.addEventListener('scroll', preventDefault, { passive: false });
        
        // Trigger the click
        document.querySelector("li[data-first='true']").click();
        
        // Restore everything after a longer delay to ensure all click handlers complete
        setTimeout(() => {
          // Remove scroll prevention
          window.removeEventListener('scroll', preventDefault);
          document.removeEventListener('scroll', preventDefault);
          
          // Restore body style
          document.body.style.cssText = originalStyle;
          
          // Restore scroll position
          window.scrollTo(0, scrollPos);
        }, 300); // Increased delay for better reliability
        
      }, 500);
    }

  }

});


document.addEventListener('DOMContentLoaded', function () {
    const customDropdowns = document.querySelectorAll('.custom-dropdown');
    let lastInitSelect = null;

    customDropdowns.forEach((customDropdown) => {
        const dropdownHeader = customDropdown.querySelector('.dropdown-header');
        const dropdownList = customDropdown.querySelector('.dropdown-list');
        const dropdownItems = Array.from(dropdownList.querySelectorAll('li'));
        const dropdownDataId = customDropdown.getAttribute('data-id');
        const originalSelect = document.querySelector(`#${dropdownDataId}`);
        let focusedIndex = -1;

      // Set initial selected value without firing change (batched below)
      dropdownItems.forEach(item => {
        if(item.classList.contains("selected")) {
          const value = item.getAttribute('data-value');
          dropdownHeader.textContent = item.textContent;
          if (originalSelect && value !== null) {
            originalSelect.value = value;
            lastInitSelect = originalSelect;
          }
        }
      })

        // Make dropdown header focusable and add proper ARIA attributes
        dropdownHeader.setAttribute('tabindex', '0');
        dropdownHeader.setAttribute('role', 'button');
        dropdownHeader.setAttribute('aria-haspopup', 'listbox');
        dropdownHeader.setAttribute('aria-expanded', 'false');

        // Toggle the custom dropdown visibility
        dropdownHeader.addEventListener('click', () => {
            toggleDropdown();
        });

        // Enhanced keyboard navigation
        customDropdown.addEventListener('keydown', (event) => {
            const isDropdownOpen = dropdownList.style.display === 'block';

            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    if (!isDropdownOpen) {
                        toggleDropdown();
                    }
                    focusNextItem(1);
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    if (!isDropdownOpen) {
                        toggleDropdown();
                    }
                    focusNextItem(-1);
                    break;
                case 'Enter':
                case ' ':
                    event.preventDefault();
                    if (isDropdownOpen && focusedIndex >= 0) {
                        selectOption(dropdownItems[focusedIndex]);
                    } else {
                        toggleDropdown();
                    }
                    break;
                case 'Escape':
                    if (isDropdownOpen) {
                        closeDropdown();
                        dropdownHeader.focus();
                    }
                    break;
                case 'Tab':
                    if (isDropdownOpen) {
                        closeDropdown();
                    }
                    break;
            }
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', (event) => {
            if (!customDropdown.contains(event.target)) {
                closeDropdown();
            }
        });

        // Handle mouse selection
        dropdownList.addEventListener('click', (event) => {
            if (event.target.tagName === 'LI') {
                selectOption(event.target);
            }
        });

        // Utility functions
        function toggleDropdown() {
            const isOpen = dropdownList.style.display === 'block';
            dropdownList.style.display = isOpen ? 'none' : 'block';
            dropdownHeader.setAttribute('aria-expanded', !isOpen);

            if (!isOpen) {
                // When opening, set first item as focusable and reset focus
                dropdownItems.forEach((item, index) => {
                    item.setAttribute('tabindex', '0');
                    item.setAttribute('role', 'option');
                });
                focusedIndex = -1;
                focusNextItem(1); // Focus first item by default
            } else {
                // When closing, remove focusability
                dropdownItems.forEach((item) => {
                    item.setAttribute('tabindex', '-1');
                });
            }
        }

        function closeDropdown() {
            dropdownList.style.display = 'none';
            dropdownHeader.setAttribute('aria-expanded', 'false');
            dropdownItems.forEach((item) => {
                item.setAttribute('tabindex', '-1');
            });
            focusedIndex = -1;
        }

        function focusNextItem(direction) {
            // Reset previously focused item
            if (focusedIndex >= 0) {
                dropdownItems[focusedIndex].classList.remove('focused');
            }

            // Update the focused index
            focusedIndex += direction;

            // Loop through items if necessary
            if (focusedIndex < 0) focusedIndex = dropdownItems.length - 1;
            if (focusedIndex >= dropdownItems.length) focusedIndex = 0;

            // Highlight the focused item
            dropdownItems[focusedIndex].classList.add('focused');
            dropdownItems[focusedIndex].focus();
        }

        function selectOption(optionElement) {
            const value = optionElement.getAttribute('data-value');
            dropdownHeader.textContent = optionElement.textContent;

            // Sync the value with the original select element
            originalSelect.value = value;

            // Trigger the `change` event for the original select
            const changeEvent = new Event('change', { bubbles: true });
            originalSelect.dispatchEvent(changeEvent);

            // Close the dropdown and focus the header
            closeDropdown();
            dropdownHeader.focus();
        }
    });

    // Fire a single change event after all dropdowns are initialized
    // so the price updates with all correct values set
    if (lastInitSelect) {
        const changeEvent = new Event('change', { bubbles: true });
        lastInitSelect.dispatchEvent(changeEvent);
    }
});



